import {connect} from 'react-redux';

import {AppSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {ConversationModel} from '../../../models/api/conversationModel';
import {LocalPreferencesFlagsEnum} from '../../../models/api/localPreferencesModel';
import {AppState} from '../../../store/appState';
import {makeGetVisualRecipientInner} from '../../../store/data/contacts/recipientsSelectors';
import {toggleFlagAction} from '../../../store/data/localPreferences/localPreferencesActions';
import {getFlags} from '../../../store/data/localPreferences/localPreferencesSelectors';
import {ChatComposer} from './chatComposer';

/*
 * Props.
 */

interface ChatComposerContainerProps {
  conversation: ConversationModel | null;
}

/*
 * Selectors.
 */

function getConversation(_state: AppState, props: ChatComposerContainerProps) {
  return props.conversation || undefined;
}

function getRecipient(_state: AppState, props: ChatComposerContainerProps) {
  return props.conversation?.recipient;
}

const getIsFormattingToolbarOpen: AppSelector<boolean> = (state) => {
  const flags = getFlags(state);
  return flags[LocalPreferencesFlagsEnum.FORMATTING_TOOLBAR_CHAT];
};

const mapStateToProps = makeMapStateToProps<ChatComposerContainerProps>()(() => ({
  visualRecipient: makeGetVisualRecipientInner(getConversation, getRecipient),
  isFormattingToolbarOpen: getIsFormattingToolbarOpen,
}));

export const ChatComposerContainer = connect(mapStateToProps, {
  onIsFormattingToolbarOpenChange: (isOpen: boolean) =>
    toggleFlagAction(LocalPreferencesFlagsEnum.FORMATTING_TOOLBAR_CHAT, isOpen),
})(ChatComposer);
